import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  // Prevent body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-214">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 bg-navy-900/60 backdrop-blur-sm" aria-hidden="true" data-id="element-215" />

          {/* Modal Content */}
          <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-216">
            <motion.div initial={{
          y: '100%',
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: '100%',
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="w-full max-w-2xl bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl pointer-events-auto max-h-[85vh] flex flex-col" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-217">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-218">
                <h2 id="modal-title" className="text-2xl font-serif font-semibold text-navy-900" data-id="element-219">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-gray-400 hover:text-navy-800 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar" data-id="element-220">
                  <X size={24} data-id="element-221" />
                </button>
              </div>

              {/* Scrollable Body */}
              <div className="p-6 overflow-y-auto" data-id="element-222">
                <div className="prose prose-slate max-w-none" data-id="element-223">{children}</div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}